/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MigrateRequestDto
 */
export interface MigrateRequestDto {
    /**
     * The template version the caller intends to migrate to (must equal the latest published version).
     * @type {number}
     * @memberof MigrateRequestDto
     */
    toVersion: number;
}

/**
 * Check if a given object implements the MigrateRequestDto interface.
 */
export function instanceOfMigrateRequestDto(value: object): value is MigrateRequestDto {
    if (!('toVersion' in value) || value['toVersion'] === undefined) return false;
    return true;
}

export function MigrateRequestDtoFromJSON(json: any): MigrateRequestDto {
    return MigrateRequestDtoFromJSONTyped(json, false);
}

export function MigrateRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MigrateRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'toVersion': json['toVersion'],
    };
}

export function MigrateRequestDtoToJSON(json: any): MigrateRequestDto {
    return MigrateRequestDtoToJSONTyped(json, false);
}

export function MigrateRequestDtoToJSONTyped(value?: MigrateRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'toVersion': value['toVersion'],
    };
}

